'use strict';
require('./SearchPortalDirective.js');

function EmailToObjectNewCtrl(
  $scope,
  priorities,
  $stateParams,
  $state,
  EmailToObjectService,
  CompanyFlowVerifiesService,
  growl,
  $translate) {
  $scope.priorities = priorities;
  $scope.$parent.nonWatchers = [];
  $scope.recv = new EmailToObjectService({groupIds: [], watchers: [], status: 'PUBLISHED'});

  CompanyFlowVerifiesService.query({companyId: $stateParams.companyId}).$promise.then(function(flowVerifies){
    $scope.flowVerifies = flowVerifies;
  });

  $scope.save = function() {
    $scope.recv.$save({
      companyId: $stateParams.companyId
    }, function(){
      growl.addSuccessMessage($translate.instant('email-to-object.create-success'));
      $state.go('root.company.account.email.list');
    }, function(){
      growl.addErrorMessage($translate.instant('email-to-object.create-failure'));
    });
  };
}

angular.module('dokiv')
  .controller('EmailToObjectNewCtrl', [
    '$scope',
    'priorities',
    '$stateParams',
    '$state',
    'EmailToObjectService',
    'CompanyFlowVerifiesService',
    'growl',
    '$translate',
    EmailToObjectNewCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-object/EmailToObjectNewCtrl.js
// module id = 344
// module chunks = 0